export default "__VITE_ASSET__DaR7v1TF__"